


import React, { useState } from 'react';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import { Menu, X } from 'react-feather';
import { MdOutlineCategory } from "react-icons/md";
import { MdProductionQuantityLimits } from "react-icons/md";
import { FiLogOut } from "react-icons/fi";
import { FaBorderAll } from "react-icons/fa6";
import { GiKnightBanner } from "react-icons/gi";
import { RiCoupon3Line } from "react-icons/ri";
import { RxDashboard } from "react-icons/rx";

const linkClass = (isActive, isCollapsed) => 
    classNames(
        'flex items-center gap-3 font-medium py-2.5 hover:bg-blue-600/30 active:bg-blue-700/40 rounded-md text-white transition-all duration-300 ease-in-out overflow-hidden',
        {
            'px-3': !isCollapsed,
            'px-2.5 justify-center': isCollapsed,
            'bg-blue-600/20 border-l-4 border-blue-400': isActive,
            'hover:border-l-4 hover:border-blue-400/50': !isActive,
        }
    );

const iconClass = (isActive) => 
    classNames('text-xl transition-colors duration-300', {
        'text-blue-400': isActive,
        'text-neutral-300 hover:text-blue-400': !isActive,
    });

export default function Sidebar() {
    const [isCollapsed, setIsCollapsed] = useState(false);

    return (
        <div
            className={classNames(
                'bg-slate-900 p-4 flex flex-col relative transition-all duration-300 ease-in-out shadow-xl',
                {
                    'w-64': !isCollapsed,
                    'w-20': isCollapsed,
                }
            )}
        >
            <div className="flex items-center px-2 py-4">
                {!isCollapsed && (
                    <span className="text-neutral-200 font-bold text-xl tracking-wide">
                        E-Payroll
                    </span>
                )}
                <button 
                    className="ml-auto p-1.5 hover:bg-slate-800 rounded-lg transition-colors duration-300"
                    onClick={() => setIsCollapsed(!isCollapsed)}
                >
                    {isCollapsed ? (
                        <Menu className="w-6 h-6 text-neutral-100 hover:text-blue-400" />
                    ) : (
                        <X className="w-6 h-6 text-neutral-100 hover:text-blue-400" />
                    )}
                </button>
            </div>
            
            <nav className="flex flex-1 flex-col gap-1.5 py-8 overflow-y-auto">
                <NavLink 
                    to="/dashboard" 
                    end // Add the `end` prop to ensure it only matches exactly `/dashboard`
                    className={({ isActive }) => linkClass(isActive, isCollapsed)}
                >
                    {({ isActive }) => (
                        <>
                            <RxDashboard className={iconClass(isActive)} />
                            {!isCollapsed && 'Dashboard'}
                        </>
                    )}
                </NavLink>

                <NavLink 
                    to="/dashboard/employee" 
                    className={({ isActive }) => linkClass(isActive, isCollapsed)}
                >
                    {({ isActive }) => (
                        <>
                            <MdOutlineCategory className={iconClass(isActive)} />
                            {!isCollapsed && 'Employee'}
                        </>
                    )}
                </NavLink>

                <NavLink 
                    to="/dashboard/attendance" 
                    className={({ isActive }) => linkClass(isActive, isCollapsed)}
                >
                    {({ isActive }) => (
                        <>
                            <GiKnightBanner className={iconClass(isActive)} />
                            {!isCollapsed && 'Attendance'}
                        </>
                    )}
                </NavLink>

                <NavLink 
                    to="/dashboard/leaves" 
                    className={({ isActive }) => linkClass(isActive, isCollapsed)}
                >
                    {({ isActive }) => (
                        <>
                            <MdProductionQuantityLimits className={iconClass(isActive)} />
                            {!isCollapsed && 'Leaves'}
                        </>
                    )}
                </NavLink>

                <NavLink 
                    to="/dashboard/task" 
                    className={({ isActive }) => linkClass(isActive, isCollapsed)}
                >
                    {({ isActive }) => (
                        <>
                            <RiCoupon3Line className={iconClass(isActive)} />
                            {!isCollapsed && 'Task'}
                        </>
                    )}
                </NavLink>
 {/*
                <NavLink 
                    to="/dashboard/order" 
                    className={({ isActive }) => linkClass(isActive, isCollapsed)}
                >
                    {({ isActive }) => (
                        <>
                            <FaBorderAll className={iconClass(isActive)} />
                            {!isCollapsed && 'Order'}
                        </>
                    )}
                </NavLink> */}

                <NavLink 
                    to="/logout" 
                    className={({ isActive }) => linkClass(isActive, isCollapsed)}
                >
                    {({ isActive }) => (
                        <>
                            <FiLogOut className={iconClass(isActive)} />
                            {!isCollapsed && 'Logout'}
                        </>
                    )}
                </NavLink>
            </nav>
        </div>
    );
}